<template>
  <v-container>
    <v-dialog v-if="mixNumberDialog" v-model="mixNumberDialog" width="600">
      <v-card>
        <v-card-title>
          Set Mix Number
        </v-card-title>
        <v-card-text>
          <v-form-field
              x-large
              autofocus
              v-model="style"
              label="Style"></v-form-field>
          <v-form-field
              x-large
              autofocus
              v-model="color"
              label="Color"></v-form-field>
          <v-form-field
              x-large
              autofocus
              v-model="mixNumber"
              label="Mix Number"></v-form-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="$store.getters.loading['MATERIAL_SET_MIX_NUMBER']" @click="setMixNumber"
                 color="primary" tile>OK
          </v-btn>
          <v-btn @click="mixNumberDialog=false" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="editDialog" v-model="editDialog" width="600">
      <v-card>
        <v-card-title>
          Edit Container Information
        </v-card-title>
        <v-card-text>
          <v-form-field
              x-large
              autofocus
              v-model="doc.containerNo"
              label="Container No"></v-form-field>
          <v-form-field
              x-large
              autofocus
              v-model="doc.sealNo"
              label="Seal No"></v-form-field>
          <v-form-field
              x-large
              autofocus
              v-model="doc.invoiceNo"
              label="Invoice No"></v-form-field>
          <v-form-field
              x-large
              autofocus
              v-model="doc.blNo"
              label="BL No"></v-form-field>
          <v-form-field
              x-large
              autofocus
              v-model="doc.hbiNo"
              label="HBI No"></v-form-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="$store.getters.loading['CONTAINER_UPDATE']" @click="updateContainer"
                 color="primary" tile>OK
          </v-btn>
          <v-btn @click="editDialog=false" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="lottiDialog" v-model="lottiDialog" width="400">
      <v-card>
        <v-card-title>
          {{ lotti }}
        </v-card-title>
        <v-card-text>
          <v-page-data-table
              :fields="sizePackingFields"
              :show-edit="false"
              dense
              hide-footer
              hide-search
              hide-toolbar
              ref="sizePacking"
              hide-row-action
              key-name="id"
              query-api="SIZE_PACKING_LIST_QUERY"
              :query-params="{sizePackingId:sizePackingId}">
          </v-page-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="lottiDialog=false"
                 color="primary" tile>OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-simple-form title="Container Info">
      <template v-slot:toolbar>
        <v-btn @click="goBack" color="rgba(0,0,0,.7)" small text tile>
          <v-icon color="gray">mdi-step-backward</v-icon>
          Back
        </v-btn>
        <v-btn v-if="isAdmin" @click="changeStatus" color="rgba(0,0,0,.7)" small text tile
               :loading="$store.getters.loading['CONTAINER_STATUS_CHANGE']">
          <v-icon color="gray">mdi-webpack</v-icon>
          Change to Loading
        </v-btn>
        <v-btn v-if="isAdmin" @click="editDialog=true;" color="rgba(0,0,0,.7)" small text tile>
          <v-icon color="gray">mdi-square-edit-outline</v-icon>
          Edit
        </v-btn>
        <v-spacer/>
      </template>
      <template v-slot:content>
        <v-row no-gutters>
          <v-col :cols="3">
            <v-form-field label="Containe No" :text="doc.containerNo" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Seal no" :text="doc.sealNo" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="BL" :text="doc.blNo" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Invoice Nr" :text="doc.invoiceNo" readonly middle></v-form-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col :cols="3">
            <v-form-field label="HBI No" :text="doc.hbiNo" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Status" :text="statusMeaning" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Total cartons" :text="doc.totalCartons" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Total Pieces" :text="doc.totalPieces" readonly middle></v-form-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col :cols="3">
            <v-form-field label="Scaned Cartons" :text="doc.fnCount" readonly middle></v-form-field>
          </v-col>
          <v-col :cols="3">
            <v-form-field label="Unscan" :text="doc.opCount" readonly middle></v-form-field>
          </v-col>
        </v-row>

      </template>
    </v-simple-form>
    <v-simple-form title="Items">
      <template v-slot:toolbar>
        <v-btn @click="onShowNoMatch" color="rgba(0,0,0,.7)" small text tile>
          <v-icon small color="gray">mdi-close-box-multiple</v-icon>
          Show No Match
        </v-btn>

        <v-btn @click="onShowNoNumber" color="rgba(0,0,0,.7)" small text tile>
          <v-icon small color="gray">mdi-closed-caption</v-icon>
          Show No Number
        </v-btn>
        <v-btn v-if="isAdmin" @click="mixNumberDialog=true;" color="rgba(0,0,0,.7)" small text tile
               :loading="$store.getters.loading['MATERIAL_SET_MIX_NUMBER']">
          <v-icon color="gray">mdi-visual-studio-code</v-icon>
          Set Mix Number
        </v-btn>
        <v-spacer/>
        <v-text-field class="vc-input__border mr-5" solo flat dense hide-details
                      clearable
                      @keydown="onSearchMaterial"
                      v-model="searchText">
        </v-text-field>
      </template>
      <template v-slot:content>
        <v-page-data-table
            :fields="processHistoryFields"
            :show-edit="false"
            hide-toolbar
            ref="material"
            hide-row-action
            key-name="id"
            query-api="MATERIAL_QUERY"
            :query-params="{containerId:docId,showNoMatch:showNoMatch,showNoNumber:showNoNumber,text:searchText}">
          <template v-slot:match="{item}">
            <v-btn text tile color="success" small v-if="item.status=='FN'">
              <v-icon small>mdi-checkbox-marked-circle</v-icon>
            </v-btn>
            <v-btn text tile color="warning" small v-else-if="item.status=='OP'">
              <v-icon color="red" small>mdi-close-circle</v-icon>
            </v-btn>
          </template>

          <template v-slot:size="{item}">
            <v-btn @click="showSizePackingDialog(item.sizePackingId,item.size)" text tile color="blue" small
                   v-if="item.isMix=='1'">
              {{ item.size }}
            </v-btn>
            <p v-else>{{ item.size }}</p>
            <!--            <v-btn text tile color="warning" small v-else>-->
            <!--              <v-icon color="red" small>mdi-close-circle</v-icon>-->
            <!--            </v-btn>-->
          </template>
        </v-page-data-table>
      </template>
    </v-simple-form>
  </v-container>
</template>

<script>

import ProcessHistoryFields from './fields/ProcessHistory'
import SizePackingFields from './fields/SizePackingFields'

export default {
  name: "ProjectDetail.vue",
  data() {
    return {
      docId: null,
      mixNumberDialog: false,
      mixNumber: null,
      style: null,
      color: null,
      searchText: null,
      editDialog: false,
      lottiDialog: false,
      keyText: null,
      lotti: null,
      processHistoryFields: ProcessHistoryFields,
      sizePackingFields: SizePackingFields,
      sizePackingId: null,
      isAdmin:false,
      doc: {
        blNo: null,
        containerNo: null,
        sealNo: null,
        etd: null,
        eta: null,
        hbiNo: null,
        totalCartons: null,
        totalPieces: null,
        status: null,
        invoiceNo: null,
        fnCount: null,
        opCount: null
      },
      showNoMatch: false,
      showNoNumber: false
    }
  },
  computed: {
    statusMeaning: function () {
      let meaning = "";
      if (this.doc.status == 'OP') {
        meaning = "OPEN";
      } else if (this.doc.status == 'PK') {
        meaning = "LOADING";
      } else if (this.doc.status == "FN") {
        meaning = "DONE";
      }
      return meaning;
    }
  },
  created() {
    this.docId = this.$route.query.id;
    if (this.docId) {
      this.queryDetail(this.docId);
    }
    this.isAdmin=this.$tool.hasRole("SMS_ADMIN");
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onShowNoMatch() {
      this.showNoNumber = false;
      this.showNoMatch = true;
      this.$refs.material.query();
    },
    onShowNoNumber() {
      this.showNoMatch = false;
      this.showNoNumber = true;
      this.$refs.material.query();
    },
    queryDetail(id) {
      this.$request
          .request("CONTAINER_DETAIL", {id: id})
          .then(response => {
            this.doc = Object.assign(this.doc, response.data);
          });
    },
    changeStatus() {
      this.$request
          .request("CONTAINER_STATUS_CHANGE", {id: this.docId, status: 'PK'})
          .then(response => {
            this.$message.success("Status change to LOADING");
          });
    },
    setMixNumber() {
      this.$request
          .request("MATERIAL_SET_MIX_NUMBER", {
            containerId: this.docId,
            mixNumber: this.mixNumber,
            style: this.style,
            color: this.color
          })
          .then(response => {
            this.$message.success("总共更新" + response.data + "条数据");
            this.mixNumberDialog = false;
            this.$refs.material.query();
          });
    },
    showSizePackingDialog(sizePackingId, size) {
      this.sizePackingId = sizePackingId;
      this.lotti = size;
      this.lottiDialog = true;
    },
    updateContainer() {
      this.$request
          .request("CONTAINER_UPDATE", this.doc)
          .then(response => {
            this.$message.success("更新成功");
            this.editDialog = false;
          });
    },
    onSearchMaterial(e) {
      if (e.keyCode === 13) {
        this.showNoNumber = false;
        this.showNoMatch = false;
        this.$refs.material.query();
      }
    }
  },
}
</script>
